import React, { useState, useEffect } from "react";
import "./ProfilePage.css";

const ProfilePage = ({ onLogout }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const savedUser = localStorage.getItem("user");
    if (savedUser) {
      try {
        const parsed = JSON.parse(savedUser);
        setUser(parsed);
      } catch (error) {
        console.error("Error parsing user data:", error);
      }
    }
  }, []);

  const userName = user?.email?.split("@")[0] || "Trader";

  return (
    <div className="profile-page-modern">
      <div className="profile-container">
        
        {/* HERO SECTION */}
        <div className="hero-section">
          <div className="hero-left">
            <div className="avatar-container">
              <div className="avatar-ring"></div>
              <div className="avatar-circle">
                {user?.picture ? (
                  <img src={user.picture} alt="Avatar" style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }} referrerPolicy="no-referrer" />
                ) : (
                  "TR"
                )}
              </div>
              <div className="verify-badge">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L3 7v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-9-5zm-2 14.5l-4-4 1.41-1.41L10 13.67l7.59-7.59L19 7.5l-9 9.5z"/>
                </svg>
              </div>
            </div>
            
            <div className="user-info">
              <div className="greeting">Welcome back,</div>
              <div className="name-row">
                {userName} 
                <span className="verified-check">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                </span>
              </div>
              <div className="subtitle">Manage your account and subscription preferences.</div>
              <div className="badges">
                <span className="badge">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
                  Member since May 2024
                </span>
                <span className="badge">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path><polyline points="9 12 11 14 15 10"></polyline></svg>
                  Verified Account
                </span>
              </div>
            </div>
          </div>

          <div className="hero-right">
            <div className="account-health-card">
              <div className="ah-icon-wrap">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#a855f7" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path><polyline points="9 12 11 14 15 10"></polyline></svg>
              </div>
              <div className="ah-text">
                <div className="ah-title">Account Health</div>
                <div className="ah-status">Secure & Active</div>
                <div className="ah-login">Last login: Today, 10:42 AM</div>
              </div>
              <div className="ah-arrow">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="9 18 15 12 9 6"></polyline></svg>
              </div>
            </div>
          </div>
        </div>

        {/* STATS ROW */}
        <div className="stats-row">
          <div className="stat-card">
            <div className="stat-icon portfolio-bg">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg>
            </div>
            <div className="stat-content">
              <div className="stat-title">Portfolio Value</div>
              <div className="stat-value">₹12,45,230.75</div>
              <div className="stat-sub text-green">
                 ↑ +3.45% Today
              </div>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon watchlist-bg">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
            </div>
            <div className="stat-content">
              <div className="stat-title">Watchlist</div>
              <div className="stat-value">24</div>
              <div className="stat-sub">Active Symbols</div>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon alerts-bg">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
            </div>
            <div className="stat-content">
              <div className="stat-title">Alerts</div>
              <div className="stat-value">7</div>
              <div className="stat-sub">Active Alerts</div>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon research-bg">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
            </div>
            <div className="stat-content">
              <div className="stat-title">Research Reports</div>
              <div className="stat-value">12</div>
              <div className="stat-sub">This Month</div>
            </div>
          </div>
        </div>

        {/* DETAILS ROW */}
        <div className="details-row">
          
          {/* Personal Details */}
          <div className="panel-card personal-details-card">
            <div className="panel-header">
              <h3>Personal Details</h3>
              <button className="edit-btn">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
                Edit
              </button>
            </div>
            
            <div className="details-list">
              <div className="detail-item">
                <div className="d-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg></div>
                <div className="d-text">
                  <div className="d-label">Full Name</div>
                  <div className="d-value">{userName}</div>
                </div>
              </div>

              <div className="detail-item">
                <div className="d-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg></div>
                <div className="d-text">
                  <div className="d-label">Email Address</div>
                  <div className="d-value-row">
                    {user?.email || "trader@example.com"}
                    {user?.isGoogleAuth && <span className="verify-pill">Verified</span>}
                  </div>
                </div>
              </div>

              <div className="detail-item">
                <div className="d-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect><line x1="12" y1="18" x2="12.01" y2="18"></line></svg></div>
                <div className="d-text">
                  <div className="d-label">Phone Number</div>
                  <div className="d-value-row">
                    +91-XXXXXXXXXX
                    <span className="verify-pill">Verified</span>
                  </div>
                </div>
              </div>

              <div className="detail-item">
                <div className="d-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg></div>
                <div className="d-text">
                  <div className="d-label">Location</div>
                  <div className="d-value">India</div>
                </div>
              </div>

              <div className="detail-item">
                <div className="d-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg></div>
                <div className="d-text">
                  <div className="d-label">Date of Birth</div>
                  <div className="d-value">--/--/----</div>
                </div>
              </div>

              <div className="detail-item">
                <div className="d-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="4" y1="9" x2="20" y2="9"></line><line x1="4" y1="15" x2="20" y2="15"></line><line x1="10" y1="3" x2="8" y2="21"></line><line x1="16" y1="3" x2="14" y2="21"></line></svg></div>
                <div className="d-text">
                  <div className="d-label">Account ID</div>
                  <div className="d-value-row">
                    ST4U-7F9K-23D1
                    <button className="copy-btn">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>
                    </button>
                  </div>
                </div>
              </div>

            </div>
          </div>

          {/* Current Plan */}
          <div className="panel-card current-plan-card">
            <div className="panel-header">
              <h3>Current Plan</h3>
              <span className="silver-badge">SILVER</span>
            </div>
            
            <div className="plan-inner">
              <div className="plan-banner">
                <div className="coin-wrapper">
                  {/* Hexagon shape mimicking silver coin */}
                  <svg width="60" height="60" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                    <polygon points="50,5 95,25 95,75 50,95 5,75 5,25" fill="#e2e8f0" stroke="#cbd5e1" strokeWidth="2"/>
                    <polygon points="50,15 85,32 85,68 50,85 15,68 15,32" fill="#cbd5e1" />
                    <path d="M50 25 L75 40 L50 70 L25 40 Z" fill="#f8fafc" />
                    <path d="M50 70 L75 40 L75 55 L50 85 Z" fill="#94a3b8" />
                  </svg>
                </div>
                <div className="plan-title-info">
                  <div className="p-title">Silver Plan</div>
                  <div className="p-validity">
                    Valid till 25 May 2025 <span className="active-badge">Active</span>
                  </div>
                </div>
              </div>

              <div className="features-grid">
                <ul className="f-list">
                  <li><span className="chk">✓</span> Track Top Gainers & Losers</li>
                  <li><span className="chk">✓</span> Comprehensive Company Insights</li>
                  <li><span className="chk">✓</span> Global Market Coverage</li>
                </ul>
                <ul className="f-list">
                  <li><span className="chk">✓</span> Advanced Charting Tools</li>
                  <li><span className="chk">✓</span> Real-time Market Data (Delayed)</li>
                  <li><span className="chk">✓</span> Email Support</li>
                </ul>
              </div>

              <button className="upgrade-btn">
                Upgrade Plan
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
              </button>
            </div>
            
            <div className="plan-footer">
              <span className="discount-txt">Save up to 25% with annual billing</span>
              <a href="#" className="pricing-link">View Plans & Pricing →</a>
            </div>
          </div>

          {/* Sign Out Section */}
          <div className="sign-out-section" style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', marginBottom: '40px' }}>
            <button 
              className="upgrade-btn" 
              style={{ background: 'rgba(239, 68, 68, 0.1)', color: '#f87171', border: '1px solid rgba(239, 68, 68, 0.2)', padding: '12px 24px', borderRadius: '12px', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', transition: 'all 0.3s ease' }}
              onClick={onLogout}
            >
              Sign Out
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
